import {
    REQUEST_ACTIVE_GEOFENCES,
    REQUEST_ACTIVE_GEOFENCES_ERROR,
    SET_ACTIVE_GEOFENCES,
    ADD_GEOFENCES,
    ADD_NEW_GEOFENCE,
    EDIT_NEW_GEOFENCE,
    SAVE_NEW_GEOFENCE,
    SAVE_NEW_GEOFENCE_SUCCESS,
    SAVE_NEW_GEOFENCE_ERROR,
    UPDATE_GEOFENCE,
    UPDATE_GEOFENCE_SUCCESS,
    UPDATE_GEOFENCE_ERROR,
    SET_GEOFENCE_VISIBLE,
    SET_ALL_GEOFENCES_VISIBLE,
    SET_GEOFENCE_AS_IMPORTED,
    START_EDITING_GEOFENCE,
    STOP_EDITING_GEOFENCE,
    EDIT_GEOFENCE_COORDINATES,
    EDIT_GEOFENCE_TYPE,
    EDIT_GEOFENCE_VALIDITY,
    EDIT_GEOFENCE_GEOJSON_PROPERTIES,
    REMOVE_GEOFENCE,
    REMOVE_GEOFENCE_ERROR,
    REMOVE_GEOFENCE_SUCCESS,
    REPLACE_GEOFENCE,
} from './actions';

import {
  SET_SELECTED_RESOURCE
} from 'APP_ROOT/components/pages/dashboard/actions';

const initialState = {
    loading: false,
    activeGeofenceIds: [], // array of geofenceIds that are active
    lookup: {}, // all geofences, indexed by id
    new: null, // holds a working copy of the new geofence (overrides dashboard selection when non-null)
    editingGeometry: null, // holds a working copy of the geometry the user is currently editing (implies edit mode active)
};

const editingGeometryReducer = (state, action) => {
    switch(action.type) {
        case ADD_NEW_GEOFENCE:
            return action.payload.editingGeometry;
        case START_EDITING_GEOFENCE:
            return action.payload;
        case STOP_EDITING_GEOFENCE:
            return null;
        case SAVE_NEW_GEOFENCE:
            return state && {
                ...state,
                pending: true
            };
        case EDIT_GEOFENCE_VALIDITY:
            return state && {
                ...state,
                ...action.payload
            };
        case SET_GEOFENCE_AS_IMPORTED:
            return state && {
                ...state,
                imported: true
            };
        case EDIT_GEOFENCE_COORDINATES:
            return state && {
                ...state,
                geometry: {
                    ...state.geometry,
                    ...action.payload
                }
            };
        case EDIT_GEOFENCE_TYPE:
        return state && {
            ...state,
            geometry: {
                ...state.geometry,
                ...action.payload
            }
        };
        case EDIT_GEOFENCE_GEOJSON_PROPERTIES:
            return state && {
                ...state,
                properties: {
                    ...state.properties,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};

const sortIdsByNameInLookup = (idArray, lookup) => {
    return idArray.sort((a, b) => {
        const aName = lookup[a] && lookup[a].name && lookup[a].name.value;
        const bName = lookup[b] && lookup[b].name && lookup[b].name.value;
        return aName > bName ?  1 : aName === bName ? 0 : -1
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case REQUEST_ACTIVE_GEOFENCES: {
            return {
                ...state,
                loading: true,
            };
        }

        case REQUEST_ACTIVE_GEOFENCES_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        }

        case SET_ACTIVE_GEOFENCES: {
            const { lookup, activeGeofenceIds } = action.payload;
            const sortedIds = sortIdsByNameInLookup([...activeGeofenceIds], lookup);
            return {
                ...state,
                loading: false,
                lookup: {
                    ...state.lookup,
                    ...lookup
                },
                activeGeofenceIds: sortedIds
            };
        }

        case ADD_GEOFENCES: {
            if (!action.payload || !action.payload.length) {
                return state;
            }
            return {
                ...state,
                lookup: {
                    ...state.lookup,
                    ...action.payload.reduce((acc, it) => {
                        acc[it.geofenceId] = it;
                        return acc;
                    }, {})
                }
            }
        }

        case ADD_NEW_GEOFENCE: {
            return {
                ...state,
                new: action.payload.new,
                editingGeometry: editingGeometryReducer(state.editingGeometry, action),
            };
        }

        case EDIT_NEW_GEOFENCE: {
            return {
                ...state,
                new: {
                    ...state.new,
                    ...action.payload
                }
            };
        }

        case STOP_EDITING_GEOFENCE: {
            return {
                ...state,
                new: null,
                editingGeometry: editingGeometryReducer(state.editingGeometry, action),
            }
        }

        case SAVE_NEW_GEOFENCE: {
            return {
                ...state,
                editingGeometry: editingGeometryReducer(state.editingGeometry, action),
                new: {
                    ...state.new,
                    pending: true
                }
            };
        }

        case SAVE_NEW_GEOFENCE_ERROR: {
            return {
                ...state,
                new: {
                    ...state.new,
                    error: action.payload.error
                }
            };
        }

        case SAVE_NEW_GEOFENCE_SUCCESS: {
            const lookup = {
                ...state.lookup,
                [action.payload.geofenceId]: action.payload
            };
            return {
                ...state,
                lookup,
                activeGeofenceIds: sortIdsByNameInLookup([...state.activeGeofenceIds, action.payload.geofenceId], lookup),
                new: null,
                editingGeometry: null
            };
        }

        case UPDATE_GEOFENCE: {
            return {
                ...state,
                lookup: {
                    ...state.lookup,
                    [action.payload.geofenceId]: {
                        ...state.lookup[action.payload.geofenceId],
                        ...action.payload
                    }
                }
            };
        }

        case UPDATE_GEOFENCE_ERROR: {
            return {
                ...state,
            };
        }

        case REPLACE_GEOFENCE: {
            const { oldId, newGeofence } = action.payload;
            return {
                ...state,
                lookup: {
                    ...state.lookup,
                    [oldId]: undefined,
                    [newGeofence.geofenceId]: newGeofence,
                },
                activeGeofenceIds: state.activeGeofenceIds.map(it => {
                    // assume the name hasn't changed and swap out old for new
                    if (it === oldId) return newGeofence.geofenceId;
                    return it;
                })
            };
        }

        case UPDATE_GEOFENCE_SUCCESS: {
            const lookup = {
                ...state.lookup,
                [action.payload.geofenceId]: {
                    ...state.lookup[action.payload.geofenceId],
                    ...action.payload
                }
            };
            return {
                ...state,
                lookup,
                activeGeofenceIds: sortIdsByNameInLookup([ ...state.activeGeofenceIds ], lookup),
            };
        }

        case SET_GEOFENCE_VISIBLE: {
            const { geofenceId, visible } = action.payload;
            const geofence = state.lookup[geofenceId];
            return {
                ...state,
                lookup: {
                    ...state.lookup,
                    [geofenceId]: {
                        ...geofence,
                        visible
                    }
                },
            };
        }

        case SET_ALL_GEOFENCES_VISIBLE: {
            const { visible } = action.payload;
            return {
                ...state,
                lookup: Object.keys(state.lookup).reduce((acc, it) => {
                    acc[it] = {
                        ...state.lookup[it],
                        visible
                    };
                    return acc;
                }, {})
            };
        }

        case REMOVE_GEOFENCE: {
            const geofenceId = action.payload;
            return {
                ...state,
                activeGeofenceIds: state.activeGeofenceIds.filter(it => it !== geofenceId),
            };
        }

        case REMOVE_GEOFENCE_ERROR: {
            // todo: put it back in activeGeofenceIds + set error on geofence
            return state;
        }

        case REMOVE_GEOFENCE_SUCCESS: {
            const geofenceId = action.payload;
            return {
                ...state,
                lookup: {
                    ...state.lookup,
                    [geofenceId]: undefined
                },
            };
        }

        case SET_SELECTED_RESOURCE: {
            if (state.new || state.editingGeometry) {
                return {
                    ...state,
                    new: undefined,
                    editingGeometry: undefined
                }
            }
            return state;
        }

        default: {
            const editingGeometry = editingGeometryReducer(state.editingGeometry, action);
            if (editingGeometry !== state.editingGeometry) {
                return {
                    ...state,
                    editingGeometry
                }
            }
            return state;
        }
    }
};

export default reducer;
